import { FONT, GAEA_COLOURS, styled, UNIT } from "@dexibit/styles";

const StyledMegaModeHeader = styled("div")`
  background-color: ${GAEA_COLOURS.UTILITY.RED.RED};
  width: 100%;
  color: white;
  text-align: center;
  padding: ${UNIT.small};
  font-size: ${FONT.HEADING_SMALL};
  box-sizing: border-box;
`;

export const MEGA_ADMIN_ACCOUNT_ID = 2;

export const MegaModeHeader = () => {
  return (
    <StyledMegaModeHeader>
      Impersonating accesso Intelligence mega account
    </StyledMegaModeHeader>
  );
};
